import { divideInNIntegers } from '../../../common/mathHelper'
import { TRANSACTION_LABEL, TRANSACTION_LABEL_LIST, TRANSACTION_LABEL_MAP } from './constants'

export const groupDetailedTable = (array = [], userName, IsConvCharge, tableData2 = [], userDetail, headers, headers2, headers3) => {
  if (!array.length) return []
  const headersList = {
    [TRANSACTION_LABEL_LIST[0]]: headers,
    [TRANSACTION_LABEL_LIST[1]]: headers2,
    [TRANSACTION_LABEL_LIST[2]]: headers3,
  }
  const newArray = array.map((item) => ({
    ...item,
    Transaction: TRANSACTION_LABEL_MAP[item.TranType] ?? '',
    TotalAmt: item.Amount,
  }))

  const groupedByPayment = groupData('PaymentMode', newArray)

  let data = []
  let quantityTotal = 0
  let totalLRAmt = 0
  let totalOtherCharges = 0
  let totalGST = 0
  let totalAmt = 0

  Object.keys(groupedByPayment).forEach((paymentMode) => {
    const grouped = transactionWiseGroupData(groupedByPayment[paymentMode], headers)
    const arr = []
    arr.push({
      [headers[0].field]: `Payment Mode: ${paymentMode}`,
      colSpan: { [headers[0].field]: headers.length },
      top: '30px',
      dataType: 'header',
    })
    TRANSACTION_LABEL_LIST.forEach((type) => {
      const list = grouped[type]
      if (list) {
        const header = headersList[type]
        const lengths = divideInNIntegers(header.length, 4)
        const pickedHeaders = []
        let index = 0
        lengths.forEach((span) => {
          pickedHeaders.push(header[index].field)
          index += span
        })
        arr.push(
          header.reduce(
            (acc, item) => {
              acc[item.field] = item.headerName
              return acc
            },
            { dataType: 'header', top: '60px' }
          )
        )
        arr.push({
          [pickedHeaders[0]]: `Transaction:${type}`,
          [pickedHeaders[1]]: `State: ${userDetail?.[0]?.Statename}`,
          [pickedHeaders[2]]: `City Name: ${userDetail?.[0]?.Cityname}`,
          [pickedHeaders[3]]: `Branch: ${userDetail?.[0]?.Branchname}`,
          dataType: 'subHeader',
          align: { [pickedHeaders[3]]: 'right' },
          top: '90px',
          colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
        })
        let sn=1;
        const numberedList = list.map(a=>a.dataType === 'entry' ? {...a, SN: sn++} : a)
        arr.push(...numberedList)
        const item = list[list.length - 1]
        const factor = item.Transaction === 'Refund' ? -1 : 1
        quantityTotal += factor * Number(item.Quantity)
        totalLRAmt += factor * Number(item.LRAmount)
        totalOtherCharges += factor * Number(item.OtherCharges)
        totalGST += factor * Number(item.GST)
        totalAmt += factor * Number(item.TotalAmt)
      }
    })

    arr.push({
      [headers[0].field]: `Net ${paymentMode} Collection: ${userName}`,
      align: { [headers[0].field]: 'right' },
      colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'Quantity') },
      Quantity: quantityTotal,
      LRAmount: totalLRAmt.toFixed(2),
      OtherCharges: totalOtherCharges.toFixed(2),
      GST: totalGST.toFixed(2),
      TotalAmt: totalAmt.toFixed(2),
      dataType: 'total',
      isPayAllTotal: true,
    })
    quantityTotal = 0
    totalLRAmt = 0
    totalOtherCharges = 0
    totalGST = 0
    totalAmt = 0
    data.push(...arr)
  })

  data.forEach((item) => {
    if (item.isPayAllTotal) {
      quantityTotal += Number(item.Quantity)
      totalLRAmt += Number(item.LRAmount)
      totalOtherCharges += Number(item.OtherCharges)
      totalGST += Number(item.GST)
      totalAmt += Number(item.TotalAmt)
    }
  })

  data.push({
    SN: `Net All Payment Collection: ${userName}`,
    colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'Quantity') },
    Quantity: quantityTotal,
    LRAmount: totalLRAmt.toFixed(2),
    OtherCharges: totalOtherCharges.toFixed(2),
    GST: totalGST.toFixed(2),
    TotalAmt: totalAmt.toFixed(2),
    dataType: 'total',
    align: { [headers[0].field]: 'right' },
  })

  if (IsConvCharge === 0) {
    const convCharge = Number(tableData2?.[0]?.TotalConvCharge || 0)

    data.push({
      [headers[0]
        .field]: `Convenience Fee (Total LRs : ${tableData2?.[0]?.TotalLRs}) (Total Units : ${tableData2?.[0]?.TotalUnis}) : ${userName}`,
      TotalAmt: convCharge.toFixed(2),
      colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'Quantity') },
      dataType: 'total',
      align: { [headers[0].field]: 'right' },
    })

    data.push({
      [headers[0].field]: `Total All Payment Collection + Convenience Fee : ${userName}`,
      colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'Quantity') },
      TotalAmt: (convCharge + totalAmt).toFixed(2),
      align: { [headers[0].field]: 'right' },
      dataType: 'total',
    })
  }
  data.unshift({
    dataType: 'header2',
    [headers[0].field]: `Detailed View (${userName})`,
    top: '0px',
    colSpan: { [headers[0].field]: headers.length },
  })
  return data
}

const transactionWiseGroupData = (array = [], headers) => {
  const grouped = groupData('Transaction', array)

  Object.keys(grouped).forEach((transaction) => {
    const totals = grouped[transaction].reduce(
      (acc, item) => {
        acc.Quantity += Number(item.Quantity || 0)
        acc.LRAmount += Number(item.LRAmount || 0)
        acc.OtherCharges += Number(item.OtherCharges || 0)
        acc.GST += Number(item.GST || 0)
        acc.TotalAmt += Number(item.TotalAmt || 0)
        return acc
      },
      {
        Quantity: 0,
        LRAmount: 0,
        OtherCharges: 0,
        GST: 0,
        TotalAmt: 0,
      }
    )

    grouped[transaction].push({
      [headers[0].field]: `Total Amount:${transaction}`,
      colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'Quantity') },
      align: { [headers[0].field]: 'right' },
      Quantity: totals.Quantity,
      LRAmount: totals.LRAmount,
      Transaction: transaction,
      OtherCharges: totals.OtherCharges,
      GST: totals.GST,
      TotalAmt: totals.TotalAmt,
      dataType: 'total',
    })
  })
  return grouped
}

export const groupData = (key, array = []) => {
  return array.reduce((acc, item) => {
    const groupKey = item?.[key]

    if (groupKey == null) {
      return acc
    }

    if (!acc[groupKey]) {
      acc[groupKey] = []
    }

    acc[groupKey].push({ ...item, dataType: 'entry' })
    return acc
  }, {})
}

const TYPE_ORDER = ['Booking', 'Delivery', 'Refund']

export const formatPaymentSummaryTable = (rows = [], userName, userDetail = [], header) => {
  if (!rows.length) return []

  const AMOUNT_FIELDS = header.slice(1, -1).map((h) => h.field)

  const createEmptyTotals = () =>
    AMOUNT_FIELDS.reduce(
      (acc, k) => {
        acc[k] = 0
        return acc
      },
      { TotalAmt: 0 }
    )

  const sumAmounts = (row) => AMOUNT_FIELDS.reduce((sum, k) => sum + Number(row[k] || 0), 0)

  const grouped = rows.reduce((acc, r) => {
    const { PaymentMode, TYPE } = r

    if (!acc[PaymentMode]) acc[PaymentMode] = {}
    if (!acc[PaymentMode][TYPE]) acc[PaymentMode][TYPE] = createEmptyTotals()

    AMOUNT_FIELDS.forEach((k) => {
      acc[PaymentMode][TYPE][k] += Number(r[k] || 0)
    })

    acc[PaymentMode][TYPE].TotalAmt += sumAmounts(r)

    return acc
  }, {})

  const result = [
    {
      [header[0].field]: `Summary View (${userName})`,
      dataType: 'header2',
      colSpan: { [header[0].field]: header.length },
    },
  ]

  const grandTotals = createEmptyTotals()
  Object.entries(grouped).forEach(([paymentMode, typeMap]) => {
    const totals = createEmptyTotals()

    const lengths = divideInNIntegers(header.length, 4)
    const pickedHeaders = []
    let index = 0
    lengths.forEach((span) => {
      pickedHeaders.push(header[index].field)
      index += span
    })
    result.push({
      [pickedHeaders[0]]: `Payment Mode: ${paymentMode}`,
      [pickedHeaders[1]]: `State: ${userDetail?.[0]?.Statename}`,
      [pickedHeaders[2]]: `City Name: ${userDetail?.[0]?.Cityname}`,
      [pickedHeaders[3]]: `Branch Name: ${userDetail?.[0]?.Branchname}`,
      dataType: 'subHeader',
      align: { [pickedHeaders[3]]: 'right' },
      colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
    })

    result.push(
      header.reduce(
        (acc, col) => {
          acc[col.field] = col.header
          return acc
        },
        { dataType: 'header' }
      )
    )

    TYPE_ORDER.forEach((type) => {
      const values = typeMap[type]
      if (!values || values.TotalAmt === 0) return

      const isRefund = type === 'Refund'
      const multiplier = isRefund ? -1 : 1

      AMOUNT_FIELDS.forEach((k) => {
        totals[k] += multiplier * values[k]
      })
      totals.TotalAmt += multiplier * values.TotalAmt

      result.push({
        Transaction: TRANSACTION_LABEL[type],
        ...values,
        TotalAmt: values.TotalAmt.toFixed(2),
        dataType: 'entry',
      })
    })

    result.push({
      [pickedHeaders[0]]: `Net ${paymentMode} Collection (A+B-C)`,
      ...totals,
      TotalAmt: totals.TotalAmt.toFixed(2),
      dataType: 'total',
    })

    AMOUNT_FIELDS.concat('TotalAmt').forEach((k) => {
      grandTotals[k] += totals[k]
    })
  })

  result.push({
    [header[0].field]: `All Total Collection (A+B-C)`,
    ...grandTotals,
    TotalAmt: grandTotals.TotalAmt.toFixed(2),
    dataType: 'total',
  })

  return result
}

export const formatToTwoDecimal = (obj) => {
  const formatted = {}
  Object.keys(obj).forEach((key) => {
    formatted[key] =
      typeof obj[key] === 'number'
        ? obj[key].toFixed(2)
        : obj[key]
  })
  return formatted
}

export const formatUserWiseSummaryTable = (rows = [], userName, userDetail = [], header) => {
  if (!rows.length) return []
  const AMOUNT_FIELDS = header.slice(1, -1).map((h) => h.field)
  const createEmptyTotals = () =>
    AMOUNT_FIELDS.reduce((acc, k) => {
      acc[k] = 0
      return acc
    }, { TotalAmt: 0 })
  const sumAmounts = (row) => AMOUNT_FIELDS.reduce((sum, k) => sum + Number(row[k] || 0), 0)

  // GROUPING PaymentMode -> TYPE -> UserName
  const grouped = rows.reduce((acc, r) => {
    const { PaymentMode, TYPE, UserName } = r

    if (!acc[PaymentMode]) acc[PaymentMode] = {}
    if (!acc[PaymentMode][TYPE]) acc[PaymentMode][TYPE] = {}
    if (!acc[PaymentMode][TYPE][UserName]) acc[PaymentMode][TYPE][UserName] = createEmptyTotals()

    AMOUNT_FIELDS.forEach((k) => {
      acc[PaymentMode][TYPE][UserName][k] += Number(r[k] || 0)
    })

    acc[PaymentMode][TYPE][UserName].TotalAmt += sumAmounts(r)

    return acc
  }, {})

  const result = [
    {
      [header[0].field]: `Summary View (${userName})`,
      dataType: 'header',
      colSpan: { [header[0].field]: header.length },
    },
  ]

  const grandTotals = createEmptyTotals()

  Object.entries(grouped).forEach(([paymentMode, typeMap]) => {
    const paymentTotals = createEmptyTotals()

    // Payment Mode Header
    const lengths = divideInNIntegers(header.length, 4)
    const pickedHeaders = []
    let index = 0
    lengths.forEach((span) => {
      pickedHeaders.push(header[index].field)
      index += span
    })

    result.push({
      [pickedHeaders[0]]: `Payment Mode: ${paymentMode}`,
      [pickedHeaders[1]]: `State: ${userDetail?.[0]?.Statename}`,
      [pickedHeaders[2]]: `City Name: ${userDetail?.[0]?.Cityname}`,
      [pickedHeaders[3]]: `Branch Name: ${userDetail?.[0]?.Branchname}`,
      dataType: 'subHeader',
      colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
    })

    // Column Header
    result.push(
      header.reduce((acc, col) => {
        acc[col.field] = col.header
        return acc
      }, { dataType: 'header' })
    )

    // TYPE GROUPS
    Object.entries(typeMap).forEach(([type, users]) => {
      const typeTotals = createEmptyTotals()

      // TYPE Header
      result.push({
        [header[0].field]: `${type}`,
        dataType: 'subHeader',
        colSpan: { [header[0].field]: header.length },
      })

      Object.entries(users).forEach(([user, values]) => {
        if (values.TotalAmt === 0) return

        AMOUNT_FIELDS.forEach((k) => {
          typeTotals[k] += values[k]
          paymentTotals[k] += values[k]
        })

        typeTotals.TotalAmt += values.TotalAmt
        paymentTotals.TotalAmt += values.TotalAmt

        result.push({
          UserName: user,
          ...values,
          TotalAmt: values.TotalAmt.toFixed(2),
          dataType: 'entry',
        })
      })

      // TYPE TOTAL (Booking Total / Delivery Total)
      // result.push({
      //   [header[0].field]: `${type} Total`,
      //   ...typeTotals,
      //   TotalAmt: typeTotals.TotalAmt.toFixed(2),
      //   dataType: 'total',
      // })
      result.push({
        [header[0].field]: `${type} Total`,
        ...formatToTwoDecimal(typeTotals),
        dataType: 'total',
      })
    })

    // Payment Mode Total
    // result.push({
    //   [header[0].field]: `Net ${paymentMode} Collection (A+B)`,
    //   ...paymentTotals,
    //   TotalAmt: paymentTotals.TotalAmt.toFixed(2),
    //   dataType: 'total',
    // })
    result.push({
      [header[0].field]: `Net ${paymentMode} Collection (A+B)`,
      ...formatToTwoDecimal(paymentTotals),
      dataType: 'total',
    })

    AMOUNT_FIELDS.concat('TotalAmt').forEach((k) => {
      grandTotals[k] += paymentTotals[k]
    })
  })

  // Grand Total
  // result.push({
  //   [header[0].field]: `All Total Collection (A+B)`,
  //   ...grandTotals,
  //   TotalAmt: grandTotals.TotalAmt.toFixed(2),
  //   dataType: 'total',
  // })
  result.push({
    [header[0].field]: `All Total Collection (A+B)`,
    ...formatToTwoDecimal(grandTotals),
    dataType: 'total',
  })

  return result
}